import { PermissionsI } from 'api/common.types';
import { ArquivoData } from 'components/user/attach_file_form';
import { uploadArquivo } from 'api';
import { MENSAGENS, validarData, verificarDatas } from 'utils/uteis';

export const tratarPermissoesUsuarioPure = (
  permissoes: PermissionsI,
  perfilID: any,
  profilesDropdownParm: PermissionsI | undefined,
): PermissionsI => {
  const permissoesAjustadas: PermissionsI = permissoes;
  const PerfilNome = profilesDropdownParm?.data
    ?.find((item) => item.uuid === perfilID)
    ?.name?.toUpperCase();
  if (PerfilNome && permissoes?.data?.length > 0) {
    if (
      PerfilNome.indexOf('MUNICIPAL') > -1 ||
      PerfilNome.indexOf('MUNICIPIO') > -1
    ) {
      permissoesAjustadas.data = permissoes.data.filter(
        (item: { name: string }) => {
          return item.name.toUpperCase().indexOf('ESTADUAL') === -1;
        },
      );
    } else {
      if (
        PerfilNome.indexOf('ESTADUAL') > -1 ||
        PerfilNome.indexOf('ESTADO') > -1
      ) {
        permissoesAjustadas.data = permissoes.data.filter(
          (item: { name: string }) => {
            return item.name.toUpperCase().indexOf('MUNICIPAL') === -1;
          },
        );
      }
    }
  }
  return permissoesAjustadas;
};

export const getNameByUuidPure = (
  uuid: string,
  list?: { data: { uuid: string; name: string }[] } | null,
) => {
  if (!list || !Array.isArray(list.data)) return 'N/A';
  const item = list.data.find((entry) => entry.uuid === uuid);
  return item ? item.name : 'N/A';
};

export const getTipoRepresentanteMunicipalPure = (
  permissaoParm?: string,
) => {
  return (
    permissaoParm?.trim().toUpperCase() === 'REPRESENTANTE LEGAL MUNICIPAL' ||
    false
  );
};

export const hasChangedPure = (original: any, updated: any) => {
  return JSON.stringify(original) !== JSON.stringify(updated);
};

export const construirUserDataPure = (values: any, arquivoUuid: any) => {
  const userData = {
    name: values?.personalData?.name ?? '',
    identification: values?.personalData?.cpf ?? '',
    email: values?.personalData?.email ?? '',
    contactList: [
      {
        type: 'CELULAR',
        value: '+55' + ((values?.personalData?.phone ?? '') as string).replace(/\D/g, ''),
      },
    ],
    position: values?.personalData?.position ?? '',
    groupUuid: values?.loginData?.group ?? '',
    profileUuid: values?.loginData?.profile ?? '',
    permissionUuid: values?.loginData?.permission ?? '',
    representativeFileUuid: arquivoUuid?.uuid,
    address: {
      municipality: values?.personalData?.municipalities ?? '',
    },
    isRegisterActive: values?.registrationData?.activeRegistration ?? false,
    isRegisterBlocked: values?.registrationData?.blockRegistration ?? false,
    hasAcceptedConfidentialityTerm: false,
    hasAcceptedTermOfUse: false,

    institutionUuid: null,
    dadosVigencia: null,
  };

  return userData;
};

export const gerarDadosAtualizadosPure = (userDetails: any, values: any) => {
  const updatedData: any = {};

  if (hasChangedPure(userDetails?.personalData.email, values.personalData.email)) {
    updatedData.email = values.personalData.email;
  }

  if (hasChangedPure(userDetails?.personalData.phone, values.personalData.phone)) {
    updatedData.contactList = [
      {
        uuid: userDetails?.personalData.uuidPhone,
        type: 'CELULAR',
        value: values.personalData.phone,
      },
    ];
  }

  if (hasChangedPure(userDetails?.personalData.position, values.personalData.position)) {
    updatedData.position = values.personalData.position;
  }

  if (hasChangedPure(userDetails?.loginData.groupUuid, values.loginData.group)) {
    updatedData.groupUuid = values.loginData.group;
  }

  if (hasChangedPure(userDetails?.loginData.profileUuid, values.loginData.profile)) {
    updatedData.profileUuid = values.loginData.profile;
  }

  if (hasChangedPure(userDetails?.loginData.permissionUuid, values.loginData.permission)) {
    updatedData.permissionUuid = values.loginData.permission;
  }

  updatedData.isRegisterActive = values.registrationData.activeRegistration;
  updatedData.representativeFileUuid = values.anexo.uuid;
  updatedData.isRegisterBlocked = values.registrationData.blockRegistration;

  return updatedData;
};

export const validarDadosPure = (
  tipoRepresentante: boolean,
  dataVigenciaInicial: string,
  dataVigenciaFinal: string,
  dataVigenciaIndeterminada: boolean,
  userFormActionLocal: string | null,
  arquivoAnexoLocal?: ArquivoData,
) => {
  if (tipoRepresentante) {
    if (!dataVigenciaInicial || dataVigenciaInicial.trim() == '') {
      return { ok: false, message: `Data de Inicio ${MENSAGENS.PREENCHIMENTO_OBRIGATORIO}` };
    }

    if (!validarData(dataVigenciaInicial)) {
      return { ok: false, message: `Data de Início ${MENSAGENS.PREENCHIMENTO_INVALIDO}` };
    }

    if (!dataVigenciaIndeterminada) {
      if (!dataVigenciaFinal || dataVigenciaFinal.trim() == '') {
        return { ok: false, message: `Data Fim ${MENSAGENS.PREENCHIMENTO_OBRIGATORIO}` };
      }

      if (!validarData(dataVigenciaFinal)) {
        return { ok: false, message: `Data Fim ${MENSAGENS.PREENCHIMENTO_INVALIDO}` };
      }

      if (!verificarDatas(dataVigenciaInicial, dataVigenciaFinal)) {
        return { ok: false, message: 'A Data Final de Vigência deve ser posterior a Data Inicial. Verifique e selecione uma Data válida para continuar' };
      }
    }

    if (
      userFormActionLocal === 'CADASTRAR' &&
      !(arquivoAnexoLocal && arquivoAnexoLocal.nomeArquivoOriginal?.length > 0)
    ) {
      return { ok: false, message: 'Para Representante Municipal o Arquivo Anexo é obrigatório' };
    }
  }

  return { ok: true };
};

export const processarArquivoAnexoHelper = async (arquivoAnexoLocal?: ArquivoData) => {
  if (!arquivoAnexoLocal) return null;

  const Resp = await uploadArquivo({
    ...arquivoAnexoLocal,
    type: 'COMPROVANTE DE REPRESENTANTE LEGAL MUNICIPAL',
  });

  if (Resp.Status === 'OK') {
    return Resp.dados;
  } else {
    return { error: Resp.Mensagem };
  }
};

// Helpers for create/update flows and parsing API user details
export const cadastrarUsuarioHelper = async (
  userData: any,
  createUserFn: (d: any) => Promise<any>,
) => {
  const response = await createUserFn(userData);

  if (response?.Status === 'OK') return response;

  const newResponse = await createUserFn({ ...userData, institutionUuid: null });
  return newResponse;
};

export const editarUsuarioHelper = async (
  userUuid: string,
  partialUpdateUserFn: (u: string, d: any) => Promise<any>,
  partialUpdateUserData: any,
) => {
  if (!userUuid) return null;
  const response = await partialUpdateUserFn(userUuid, partialUpdateUserData);
  return response;
};

export const parseUserDetailsPure = async (
  resp: any,
  permissions: PermissionsI | undefined,
  profiles: any,
  groups: any,
  getUserVigenciasFn?: (uuid: string) => Promise<any>,
) => {
  const userDetailsData: any = resp;
  const UserAux = userDetailsData?.data?.[0] ?? {};

  const groupUuid = UserAux.permission?.profile?.group?.uuid;
  const profileUuidAux = UserAux.permission?.profile?.uuid;
  const permissaoID = UserAux.permission?.uuid;

  let permissaoNome;
  if (permissions && permissaoID) {
    permissaoNome = permissions.data.find((item: { uuid: any }) => item.uuid === permissaoID)?.name;
  }

  let dadosVigencia = null;
  if (getTipoRepresentanteMunicipalPure(permissaoNome) && getUserVigenciasFn) {
    dadosVigencia = await getUserVigenciasFn(UserAux.uuid);
    dadosVigencia = dadosVigencia?.data;
    if (dadosVigencia && Array.isArray(dadosVigencia)) {
      dadosVigencia = dadosVigencia[0];
    }
  }

  const parsed = {
    user: UserAux,
    permissaoNome,
    dadosVigencia,
    groupUuid,
    profileUuidAux,
  };

  return parsed;
};
